var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App/info-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66385 2.16533C8.99055 1.57209 10.4649 1.25 12 1.25C17.9342 1.25 22.75 6.06579 22.75 12C22.75 17.9342 17.9342 22.75 12 22.75C6.06579 22.75 1.25 17.9342 1.25 12C1.25 9.5809 2.0568 7.34452 3.39957 5.55058C3.64778 5.21897 4.11782 5.15136 4.44942 5.39957C4.78103 5.64778 4.84864 6.11782 4.60043 6.44942C3.4432 7.99548 2.75 9.9191 2.75 12C2.75 17.1058 6.89421 21.25 12 21.25C17.1058 21.25 21.25 17.1058 21.25 12C21.25 6.89421 17.1058 2.75 12 2.75C10.6751 2.75 9.40945 3.02791 8.27615 3.53467C7.89802 3.70375 7.45441 3.53428 7.28533 3.15615C7.11625 2.77802 7.28572 2.33441 7.66385 2.16533Z",
    fill: "#A94FE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 10.25C12.4123 10.25 12.748 10.5858 12.748 11V16C12.748 16.4142 12.4123 16.75 11.998 16.75C11.5838 16.75 11.248 16.4142 11.248 16V11C11.248 10.5858 11.5838 10.25 11.998 10.25Z",
    fill: "#A94FE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9946 8C10.9946 7.44772 11.4423 7 11.9946 7H12.0036C12.5559 7 13.0036 7.44772 13.0036 8C13.0036 8.55228 12.5559 9 12.0036 9H11.9946C11.4423 9 10.9946 8.55228 10.9946 8Z",
    fill: "#A94FE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.2a9e2142423d65fa86201fff5ba420a5.svg";
export { ForwardRef as ReactComponent };